import * as ng from 'angular';
import * as Linq from 'linq-es5';
import { ComponentRegistration } from '../../core';
import { IAuthService, IProfileSecurityResource, IUserResource } from './';
import { ISiteConfigService } from '../../core';
let template = require('./forgot-password.html');

class ForgotPasswordComponent extends ComponentRegistration {

    constructor() {
        super('forgotPassword', {
            controller: ForgotPasswordController,
            templateUrl: template,
            controllerAs: 'forgotPassword',
            bindings: {
            }
        });
    }
}

interface IForgotPasswordController {
    activate(): void;
    onGetSecurityQuestionClick(): void;
    handleValidationError(formName, fieldName, fieldKey, errors): void;
    onGetPasswordLinkClick(): void;
}

class ForgotPasswordController implements IForgotPasswordController {
    private static $inject: Array<string> = ['$scope', '$window', '$rootRouter', 'User', 'SiteConfig', 'Auth', 'ProfileSecurity'];

    private linkRequest = {
        question: 'Unknown question?',
        baseUri: '',
        challengeSecret: ''  // user's answer to their security question
    };

    private questionRequest: any = {};
    private showEnterEmailStep: Boolean = true;
    private showAskQuestionStep: Boolean = false;
    private showSentStep: Boolean = false;
    private errorMessages: any = {};
    private failedPost: Boolean = false;
    private emailForm: ng.IFormController;
    private answerForm: ng.IFormController;


    constructor(private $scope: ng.IScope,
        private $window: ng.IWindowService,
        private $router: ng.Router,
        private User: IUserResource,
        private SiteConfig: ISiteConfigService,
        private Auth: IAuthService,
        private ProfileSecurity: IProfileSecurityResource) {

        console.log('ForgotPasswordController loaded');

        this.activate();

    }

    public activate(): void {
        this.SiteConfig.getConfigAsync().then((config) => {
            this.linkRequest.baseUri = config.baseUri + "/#/reset-password";
        });
        console.log('ForgotPasswordController activated');
    }

    public onGetSecurityQuestionClick(): void {
        var form = this.emailForm;
        var hasServerError = false;
        if (this.errorMessages.modelState) {
            hasServerError = Linq.From(Object.keys(this.errorMessages.modelState))
                .Any((x) => {
                    return (form as any).email.$error[x] !== undefined;
                });
        }



        if (!form.$invalid || (form.$invalid && hasServerError)) {

            this.ProfileSecurity.get({ username: this.questionRequest.email }).$promise
                .then((response: any) => {
                    if (response && response.questionText) {
                        this.linkRequest.question = response.questionText;
                        this.showAskQuestionStep = true;
                        this.showEnterEmailStep = false;
                        this.failedPost = false;
                        (form as any).email.$error = {};
                    }
                },
                (error) => {
                    if (error.status === 404) {
                        this.failedPost = true;
                        this.errorMessages = error.data;
                        this.handleValidationError("emailForm", "email", "Email", this.errorMessages);
                    }
                    else {
                        console.log("Unexpected error: " + error.status.toString());
                    }

                });
        }
        else {
            this.failedPost = true;
        }
    }

    public handleValidationError(formName, fieldName, fieldKey, errors): void {
        var form = this[formName];
        var field = form[fieldName];
        field.$error = {};

        Linq.From(errors)
            .Where((x: any) => { return x.memberNames.indexOf(fieldKey) >= 0; }).ToArray()
            .forEach((x: any) => {
                field.$error[x.errorType] = !x.success;
                console.log(x.errorMessage);
            });
    }

    public onGetPasswordLinkClick(): void {

        var form = this.answerForm;
        var hasServerError = false;
        if (this.errorMessages.modelState) {
            hasServerError = Linq.From(Object.keys(this.errorMessages.modelState))
                .Any((x) => {

                    return (form as any).challengeSecret.$error[x] !== undefined;
                });
        }


        if (!form.$invalid || (form.$invalid && hasServerError)) {
            var data = {
                baseUri: this.linkRequest.baseUri,
                challengeSecret: this.linkRequest.challengeSecret,
                username: this.questionRequest.email

            };

            this.User.forgotPasswordRequestLink(data).$promise
                .then((response) => {
                    if (response) {
                        this.showAskQuestionStep = false;
                        this.showSentStep = true;
                        (form as any).challengeSecret.$error = {};
                        setTimeout(() => {
                            this.$router.navigate(['Home']);
                        }, 15000);
                    }

                },
                (error) => {
                    if (error.status === 400) {
                        this.failedPost = true;
                        this.errorMessages = error.data;
                        this.handleValidationError("answerForm", "challengeSecret", "ChallengeSecret", this.errorMessages);
                    }
                    else {
                        console.log("Unexpected error: " + error.status.toString());
                    }
                });
        }
        else {
            this.failedPost = true;
        }
    }
}

let fgtpwdComponent = new ForgotPasswordComponent();
export default fgtpwdComponent;
export { fgtpwdComponent as ForgotPasswordComponent, IForgotPasswordController, ForgotPasswordController }


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/components/security/forgot-password.ts